import {Directive, EventEmitter, HostBinding, HostListener, Input, Output} from '@angular/core';

@Directive({selector: '[long-press]'})
export class LongPress {
  constructor() {
  }

  @Input() duration: number = 500;

  @Output() onLongPress: EventEmitter<any> = new EventEmitter();

  private focused: boolean;
  private longPressing: boolean;
  private timeout: any;
  private mouseX: number = 0;
  private mouseY: number = 0;

  @HostBinding('class.longpress')
  get longPress() {
    return this.longPressing;
  }

  @HostListener('ionFocus', ['$event'])
  onFocus(event) {
    this.focused = true;
  }

  @HostListener('ionBlur', ['$event'])
  onBlur(event) {
    // console.log('[LONG PRESS] blur');
    this.focused = false;
  }

  @HostListener('touchstart', ['$event'])
  onMouseDown(event) {
    // console.log('[LONG PRESS] touch start');
    this.mouseX = event.clientX;
    this.mouseY = event.clientY;
    this.longPressing = true;

    this.timeout = setTimeout(() => {
      if (this.longPressing && !this.focused) {
        this.longPressing = false;
        this.onLongPress.emit(event);
      }
    }, this.duration);
  }

  @HostListener('touchmove', ['$event'])
  onMouseMove(event) {
    // console.log('[LONG PRESS] touch move');
    if (this.longPressing) {
      const xThres = (event.clientX - this.mouseX) > 10;
      const yThres = (event.clientY - this.mouseY) > 10;
      if (xThres || yThres) {
        this.endPress();
      }
    }
  }

  @HostListener('touchend')
  onMouseUp() {
    this.endPress();
  }

  endPress() {
    clearTimeout(this.timeout);
    this.longPressing = false;
  }


}



// WEBPACK FOOTER //
// ./src/directives/long-press/long-press.ts